import axios from "axios";

// const baseURL = "https://localhost:7131";
const baseURL = process.env.REACT_APP_API_BASE_URL || "";
const http = axios.create({ baseURL });

export type LoginResult = { token: string; refreshToken: string };

export const userApi = {
  login: async (payload: { email: string; password: string ; oem: string}) => {
    const { data } = await http.post("/UserOemAuth/login", payload);
    return data as LoginResult;
  },
  refresh: async (payload: { email: string; refreshToken: string }) => {
    const { data } = await http.post("/UserOemAuth/refresh-token", payload);
    return data as LoginResult;
  },

  forgotPassword: async (payload: { email: string }) => {
    console.log("API service reset email",payload);
    const { data } = await http.post("/UserOemAuth/forgot-password", payload);
    return data; // backend usually returns { message: "..."} or success flag
  },

   resetPassword: async (payload: {
    email: string;
    oldPassword: string;
    newPassword: string;
    oem:string;
  }) => {
    console.log("Reset Password API payload", payload);
    const { data } = await http.post("/UserOemAuth/reset-password", payload);
    return data; // expected response: { success: true, message: "Password changed" }
  },
};

